import MergedTableHeader from "../../../component/common/dataGrid/MergedTableHeader";
import Loading from "../../../component/common/loading/Loading";

import '../../../css/data-grid.css';
import { useDynamicStyle } from "../../../hooks/useDynamicStyle";
import { NullSalgu, EmptySalgu } from '../../../images/icons/icons_component'

const TrmsSubTable = ({ subState }) => {

    const subData = subState.dataList;
    const isSearched = subState.isSearched;
    const isLoading = subState.isLoading;
    const subHead = subState.subHead;
    const subColumn = subState.subColumn;
    
    // Dynamic Style Hook
    const { fontColor, subTitleBorder, lightBackColor } = useDynamicStyle();

    return (
        <div className='data_grid_container hp-40 v2_info_media_set'>
            <div className={`flex mr-1 ${subTitleBorder}`}>
                <strong className={`ml-1 ${fontColor}`}>환자검사 및 치료정보</strong>
            </div>
            {isLoading ? <Loading /> :
                <>
                    <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                        <table>
                            <colgroup>
                                <col width="5%" />
                                <col width="10%" />
                                <col width="30%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="10%" />
                                <col width="20%" />
                            </colgroup>
                            <MergedTableHeader
                                headers={subHead}
                            />
                            <tbody>
                                {subData && subData.length > 0 ? (
                                    subData.map((item, index) => {
                                        const gridColor = index % 2 === 0 ? lightBackColor : '';
                                        return (<tr key={index} className={gridColor}>
                                            {subColumn.map((col, i) => (
                                                <td key={i}>{item[col]}</td>
                                            ))}
                                        </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={1000} className='empty_box'>
                                            <span className={`data_empty ${lightBackColor}`} style={{ padding: '0.5rem', gap: '0.25rem' }}>
                                                {isSearched ?
                                                    <>
                                                        <EmptySalgu /> 해당하는 데이터가 없습니다.
                                                    </>
                                                :
                                                    <>
                                                        <NullSalgu /> 외상환자를 선택해주세요.
                                                    </>
                                                }
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray' />
                </>
            }
        </div>
    )
}

export default TrmsSubTable;